import { z } from "zod";
import { representationSchema } from "../auth/determineRepresentation";
import { LOCALES } from "../internationalization/Locale";
import isPlainObject from "../objects/isPlainObject";
import isString from "../strings/isString";
import type { User } from "~/models/user/User";

const isUser = (user: unknown): user is User =>
  isPlainObject(user) && isString(user.email);

const schema = z.object({
  user: z.custom<User>(isUser).nullable(),
  representation: representationSchema,
  useLogRocket: z.boolean(),
  locale: z.enum(LOCALES),
  ENV: z.object({
    ENABLE_SENTRY: z.boolean(),
    ENVIRONMENT: z.string(),
  }),
});

export type RootLoaderData = z.infer<typeof schema>;

export const RootLoaderData = {
  safeParse: (data: unknown) => schema.safeParse(data),
};
